module.exports = __webpack_public_path__ + "static/media/dots_more.b46ea4eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/dots_more.svg
// module id = 1543
// module chunks = 0